
const baseData =  [
  {
      "resourceNo": "DECA001",
      "tripNo": "T000444",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-01-06",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-01-07",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 30000,
      "actionCode": "START TRIP",
      "county": "",
      "country": "",
      "addresscode": "",
      "addressname": "",
      "address": "",
      "address2": "",
      "postCode": "",
      "city": "",
      "sequenceNo": -1,
      "startingDate": "2023-01-06",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "DECA001",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": true,
      "status": "10",
      "auxiliaryIndex1": "T000444",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "DECA001",
      "tripNo": "T000444",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-01-06",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-01-07",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 10000,
      "actionCode": "LOADDEPOT",
      "county": "",
      "country": "BE",
      "addresscode": "COMP00014",
      "addressname": "Cotton Park",
      "address": "",
      "address2": "",
      "postCode": "8500",
      "city": "KORTRIJK",
      "sequenceNo": 1,
      "startingDate": "2023-01-06",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "DECA001",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "T000444",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "DECA001",
      "tripNo": "T000444",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-01-06",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-01-07",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 20000,
      "actionCode": "UNLOAD",
      "county": "",
      "country": "GB",
      "addresscode": "ABZ",
      "addressname": "DYCE",
      "address": "",
      "address2": "",
      "postCode": "",
      "city": "ABERDEEN",
      "sequenceNo": 2,
      "startingDate": "2023-01-07",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "DECA001",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "T000444",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "DECA001",
      "tripNo": "T000444",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-01-06",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-01-07",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 40000,
      "actionCode": "STOP TRIP",
      "county": "",
      "country": "",
      "addresscode": "",
      "addressname": "",
      "address": "",
      "address2": "",
      "postCode": "",
      "city": "",
      "sequenceNo": 999,
      "startingDate": "2023-01-07",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "DECA001",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "T000444",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "DUPLI",
      "tripNo": "T000448",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-02-17",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-02-17",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 50000,
      "actionCode": "START TRIP",
      "county": "",
      "country": "",
      "addresscode": "",
      "addressname": "",
      "address": "",
      "address2": "",
      "postCode": "",
      "city": "",
      "sequenceNo": -1,
      "startingDate": "2023-02-17",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "DUPLI",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": true,
      "status": "10",
      "auxiliaryIndex1": "T000448",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "DUPLI",
      "tripNo": "T000448",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-02-17",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-02-17",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 10000,
      "actionCode": "LOAD",
      "county": "",
      "country": "US",
      "addresscode": "0A7",
      "addressname": "HENDERSONVILLE AIRPORT",
      "address": "",
      "address2": "",
      "postCode": "",
      "city": "HENDERSONVILLE",
      "sequenceNo": 1,
      "startingDate": "2023-02-17",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "DUPLI",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "T000448",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "DUPLI",
      "tripNo": "T000448",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-02-17",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-02-17",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 30000,
      "actionCode": "UNLOADDEPOT",
      "county": "",
      "country": "BE",
      "addresscode": "COMP00014",
      "addressname": "Cotton Park",
      "address": "",
      "address2": "",
      "postCode": "8500",
      "city": "KORTRIJK",
      "sequenceNo": 2,
      "startingDate": "2023-02-17",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "DUPLI",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "T000448",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "DUPLI",
      "tripNo": "T000448",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-02-17",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-02-17",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 20000,
      "actionCode": "LOADDEPOT",
      "county": "",
      "country": "BE",
      "addresscode": "COMP00014",
      "addressname": "Cotton Park",
      "address": "",
      "address2": "",
      "postCode": "8500",
      "city": "KORTRIJK",
      "sequenceNo": 3,
      "startingDate": "2023-02-17",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "DUPLI",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "T000448",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "DUPLI",
      "tripNo": "T000448",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-02-17",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-02-17",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 40000,
      "actionCode": "UNLOADDEPOT",
      "county": "",
      "country": "BE",
      "addresscode": "ADR-0005441",
      "addressname": "TLER BELGIE",
      "address": "",
      "address2": "",
      "postCode": "8380",
      "city": "LISSEWEGE",
      "sequenceNo": 4,
      "startingDate": "2023-02-17",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "DUPLI",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "T000448",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "DUPLI",
      "tripNo": "T000448",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-02-17",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-02-17",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 60000,
      "actionCode": "STOP TRIP",
      "county": "",
      "country": "",
      "addresscode": "",
      "addressname": "",
      "address": "",
      "address2": "",
      "postCode": "",
      "city": "",
      "sequenceNo": 999,
      "startingDate": "2023-02-17",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "DUPLI",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "T000448",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "PAL",
      "tripNo": "T000442",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-01-21",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-01-22",
      "inManualMode": false,
      "changingSeq": "BHAVESH KUMAR",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 70000,
      "actionCode": "START TRIP",
      "county": "",
      "country": "",
      "addresscode": "",
      "addressname": "",
      "address": "",
      "address2": "",
      "postCode": "",
      "city": "",
      "sequenceNo": -1,
      "startingDate": "2023-01-21",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "PAL",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": true,
      "status": "10",
      "auxiliaryIndex1": "T000442",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "PAL",
      "tripNo": "T000442",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-01-21",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-01-22",
      "inManualMode": false,
      "changingSeq": "BHAVESH KUMAR",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 20000,
      "actionCode": "LOADDEPOT",
      "county": "",
      "country": "BE",
      "addresscode": "COMP00014",
      "addressname": "Cotton Park",
      "address": "",
      "address2": "",
      "postCode": "8500",
      "city": "KORTRIJK",
      "sequenceNo": 1,
      "startingDate": "2023-01-21",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "PAL",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "T000442",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "PAL",
      "tripNo": "T000442",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-01-21",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-01-22",
      "inManualMode": false,
      "changingSeq": "BHAVESH KUMAR",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 40000,
      "actionCode": "UNLOADDEPOT",
      "county": "",
      "country": "FR",
      "addresscode": "ADR-0005125",
      "addressname": "DEPOT FRANCE",
      "address": "",
      "address2": "",
      "postCode": "75001",
      "city": "PARIS",
      "sequenceNo": 2,
      "startingDate": "2023-01-21",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "PAL",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "T000442",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "PAL",
      "tripNo": "T000442",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-01-21",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-01-22",
      "inManualMode": false,
      "changingSeq": "BHAVESH KUMAR",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 50000,
      "actionCode": "LOADDEPOT",
      "county": "",
      "country": "FR",
      "addresscode": "ADR-0005125",
      "addressname": "DEPOT FRANCE",
      "address": "",
      "address2": "",
      "postCode": "75001",
      "city": "PARIS",
      "sequenceNo": 3,
      "startingDate": "2023-01-21",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "PAL",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "T000442",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "PAL",
      "tripNo": "T000442",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-01-21",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-01-22",
      "inManualMode": false,
      "changingSeq": "BHAVESH KUMAR",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 10000,
      "actionCode": "LOAD",
      "county": "",
      "country": "",
      "addresscode": "",
      "addressname": "",
      "address": "",
      "address2": "",
      "postCode": "",
      "city": "",
      "sequenceNo": 4,
      "startingDate": "2023-01-21",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "PAL",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "T000442",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "PAL",
      "tripNo": "T000442",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-01-21",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-01-22",
      "inManualMode": false,
      "changingSeq": "BHAVESH KUMAR",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 30000,
      "actionCode": "UNLOADDEPOT",
      "county": "",
      "country": "BE",
      "addresscode": "COMP00014",
      "addressname": "Cotton Park",
      "address": "",
      "address2": "",
      "postCode": "8500",
      "city": "KORTRIJK",
      "sequenceNo": 5,
      "startingDate": "2023-01-21",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "PAL",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "T000442",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "PAL",
      "tripNo": "T000442",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-01-21",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-01-22",
      "inManualMode": false,
      "changingSeq": "BHAVESH KUMAR",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 60000,
      "actionCode": "UNLOAD",
      "county": "",
      "country": "FR",
      "addresscode": "ADR-0005240",
      "addressname": "MAISON DE LA PROVENCE",
      "address": "",
      "address2": "",
      "postCode": "84220",
      "city": "GOULT",
      "sequenceNo": 6,
      "startingDate": "2023-01-22",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "PAL",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "T000442",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "PAL",
      "tripNo": "T000442",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-01-21",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-01-22",
      "inManualMode": false,
      "changingSeq": "BHAVESH KUMAR",
      "planDepartment": "BEZ",
      "planSubdepartment": "BE",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 80000,
      "actionCode": "STOP TRIP",
      "county": "",
      "country": "",
      "addresscode": "",
      "addressname": "",
      "address": "",
      "address2": "",
      "postCode": "",
      "city": "",
      "sequenceNo": 999,
      "startingDate": "2023-01-22",
      "startingTime": "00:00:00",
      "trailer": "CHAS-0003",
      "driver": "E0740",
      "vehicle": "PAL",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "T000442",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "VEH-00001",
      "tripNo": "TTR-9000466",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-09-06",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-09-06",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "HARELBEKE",
      "planSubdepartment": "NAT",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 10000,
      "actionCode": "START TRIP",
      "county": "",
      "country": "",
      "addresscode": "",
      "addressname": "",
      "address": "",
      "address2": "",
      "postCode": "",
      "city": "",
      "sequenceNo": 1,
      "startingDate": "2023-09-06",
      "startingTime": "00:00:00",
      "trailer": "",
      "driver": "",
      "vehicle": "VEH-00001",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "TTR-9000466",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "VEH-00001",
      "tripNo": "TTR-9000466",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-09-06",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-09-06",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "HARELBEKE",
      "planSubdepartment": "NAT",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 20000,
      "actionCode": "LOADDEPOT",
      "county": "",
      "country": "BE",
      "addresscode": "ADR-0005146",
      "addressname": "Cross-docking Harelbeke",
      "address": "Kortrijksesteenweg 321",
      "address2": "",
      "postCode": "8530",
      "city": "HARELBEKE",
      "sequenceNo": 2,
      "startingDate": "2023-09-06",
      "startingTime": "00:00:00",
      "trailer": "",
      "driver": "",
      "vehicle": "VEH-00001",
      "durationHM": 0,
      "actionDurationHM": 4,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "TTR-9000466",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "VEH-00001",
      "tripNo": "TTR-9000466",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-09-06",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-09-06",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "HARELBEKE",
      "planSubdepartment": "NAT",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 30000,
      "actionCode": "UNLOAD",
      "county": "",
      "country": "BE",
      "addresscode": "ADR-0000078",
      "addressname": "COMPAGNIE d'O $$",
      "address": "VAARTSTRAAT 6",
      "address2": "",
      "postCode": "8000",
      "city": "BRUGGE",
      "sequenceNo": 3,
      "startingDate": "2023-09-06",
      "startingTime": "00:00:00",
      "trailer": "",
      "driver": "",
      "vehicle": "VEH-00001",
      "durationHM": 0.54,
      "actionDurationHM": 1,
      "distance": 59,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "TTR-9000466",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "VEH-00001",
      "tripNo": "TTR-9000466",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-09-06",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-09-06",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "HARELBEKE",
      "planSubdepartment": "NAT",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 50000,
      "actionCode": "CAL-DOV",
      "county": "",
      "country": "FR",
      "addresscode": "USCAL",
      "addressname": "HARBOUR CALAIS",
      "address": "",
      "address2": "",
      "postCode": "62100",
      "city": "CALAIS",
      "sequenceNo": 4,
      "startingDate": "2023-09-05",
      "startingTime": "23:00:00",
      "trailer": "",
      "driver": "",
      "vehicle": "VEH-00001",
      "durationHM": 1.48,
      "actionDurationHM": 1,
      "distance": 119,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "TTR-9000466",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "VEH-00001",
      "tripNo": "TTR-9000466",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-09-06",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-09-06",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "HARELBEKE",
      "planSubdepartment": "NAT",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 40000,
      "actionCode": "STOP TRIP",
      "county": "",
      "country": "",
      "addresscode": "",
      "addressname": "",
      "address": "",
      "address2": "",
      "postCode": "",
      "city": "",
      "sequenceNo": 5,
      "startingDate": "2023-09-06",
      "startingTime": "00:00:00",
      "trailer": "",
      "driver": "",
      "vehicle": "VEH-00001",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "TTR-9000466",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "VEH-00001",
      "tripNo": "TTR-9000466",
      "partialtripLineNo": 10000,
      "ptStartingDate": "2023-09-06",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-09-06",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "HARELBEKE",
      "planSubdepartment": "NAT",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 60000,
      "actionCode": "ARRIVALFERRY",
      "county": "",
      "country": "GB",
      "addresscode": "ADR-0004768",
      "addressname": "ANGLO OVERSEAS LTD DOVER OFFIC",
      "address": "CHANNEL VIEW ROAD",
      "address2": "DORNACK HOUSE",
      "postCode": "CT17 9TP",
      "city": "DOVER, KENT",
      "sequenceNo": 5,
      "startingDate": "2023-09-06",
      "startingTime": "07:00:00",
      "trailer": "",
      "driver": "",
      "vehicle": "VEH-00001",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 8,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "TTR-9000466",
      "auxiliaryIndex2": 10000
  },
  {
      "resourceNo": "VEH-00001",
      "tripNo": "TTR-9000466",
      "partialtripLineNo": 20000,
      "ptStartingDate": "2023-09-06",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-09-06",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "HARELBEKE",
      "planSubdepartment": "NAT",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 10000,
      "actionCode": "START TRIP",
      "county": "",
      "country": "",
      "addresscode": "",
      "addressname": "",
      "address": "",
      "address2": "",
      "postCode": "",
      "city": "",
      "sequenceNo": -1,
      "startingDate": "2023-09-06",
      "startingTime": "00:00:00",
      "trailer": "",
      "driver": "",
      "vehicle": "VEH-00001",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Calculated",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "TTR-9000466",
      "auxiliaryIndex2": 20000
  },
  {
      "resourceNo": "VEH-00001",
      "tripNo": "TTR-9000466",
      "partialtripLineNo": 20000,
      "ptStartingDate": "2023-09-06",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-09-06",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "HARELBEKE",
      "planSubdepartment": "NAT",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 30000,
      "actionCode": "LOADDEPOT",
      "county": "",
      "country": "NL",
      "addresscode": "ADR-0005098",
      "addressname": "J.C. VERNOOIJ B.V.",
      "address": "THOOG 5",
      "address2": "",
      "postCode": "3451 RC",
      "city": "VLEUTEN",
      "sequenceNo": 1,
      "startingDate": "2023-09-06",
      "startingTime": "01:00:00",
      "trailer": "",
      "driver": "",
      "vehicle": "VEH-00001",
      "durationHM": 1,
      "actionDurationHM": 4,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "TTR-9000466",
      "auxiliaryIndex2": 20000
  },
  {
      "resourceNo": "VEH-00001",
      "tripNo": "TTR-9000466",
      "partialtripLineNo": 20000,
      "ptStartingDate": "2023-09-06",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-09-06",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "HARELBEKE",
      "planSubdepartment": "NAT",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 40000,
      "actionCode": "UNLOADDEPOT",
      "county": "",
      "country": "BE",
      "addresscode": "ADR-0005146",
      "addressname": "Cross-docking Harelbeke",
      "address": "Kortrijksesteenweg 321",
      "address2": "",
      "postCode": "8530",
      "city": "HARELBEKE",
      "sequenceNo": 2,
      "startingDate": "2023-09-06",
      "startingTime": "08:15:00",
      "trailer": "",
      "driver": "",
      "vehicle": "VEH-00001",
      "durationHM": 3.15,
      "actionDurationHM": 0.15,
      "distance": 229,
      "driveDurationHM": 3.15,
      "restDurationHM": 0,
      "drivingState": "Calculated",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "TTR-9000466",
      "auxiliaryIndex2": 20000
  },
  {
      "resourceNo": "VEH-00001",
      "tripNo": "TTR-9000466",
      "partialtripLineNo": 20000,
      "ptStartingDate": "2023-09-06",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-09-06",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "HARELBEKE",
      "planSubdepartment": "NAT",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 50000,
      "actionCode": "STARTEMPTY",
      "county": "",
      "country": "",
      "addresscode": "",
      "addressname": "vdt",
      "address": "",
      "address2": "",
      "postCode": "",
      "city": "",
      "sequenceNo": 3,
      "startingDate": "2023-09-06",
      "startingTime": "09:30:00",
      "trailer": "",
      "driver": "",
      "vehicle": "VEH-00001",
      "durationHM": 1,
      "actionDurationHM": 1,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Default",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "TTR-9000466",
      "auxiliaryIndex2": 20000
  },
  {
      "resourceNo": "VEH-00001",
      "tripNo": "TTR-9000466",
      "partialtripLineNo": 20000,
      "ptStartingDate": "2023-09-06",
      "startTime": "00:00:00",
      "ptEndingDate": "2023-09-06",
      "inManualMode": false,
      "changingSeq": "",
      "planDepartment": "HARELBEKE",
      "planSubdepartment": "NAT",
      "ptStatus": "10",
      "splitMethod": " ",
      "emptyTrip": false,
      "routeLineNo": 20000,
      "actionCode": "STOP TRIP",
      "county": "",
      "country": "",
      "addresscode": "",
      "addressname": "",
      "address": "",
      "address2": "",
      "postCode": "",
      "city": "",
      "sequenceNo": 999,
      "startingDate": "2023-09-06",
      "startingTime": "10:30:00",
      "trailer": "",
      "driver": "",
      "vehicle": "VEH-00001",
      "durationHM": 0,
      "actionDurationHM": 0,
      "distance": 0,
      "driveDurationHM": 0,
      "restDurationHM": 0,
      "drivingState": "Calculated",
      "dummyAction": false,
      "hideDummyAction": false,
      "chassis": "",
      "fixedActionTime": false,
      "status": "10",
      "auxiliaryIndex1": "TTR-9000466",
      "auxiliaryIndex2": 20000
  }
];
export const customModelFields = {
  id: 'TaskID',
  title: 'Title',
  description: 'Description',
  start: 'Start',
  end: 'End',
  // recurrenceRule: 'RecurrenceRule',
  // recurrenceId: 'RecurrenceID',
  // recurrenceExceptions: 'RecurrenceException',
  imgUrl: 'ImageUrl'
};
const currentYear = new Date().getFullYear();
  const parseAdjust = eventDate => {
  const date = new Date(eventDate);
  date.setFullYear(currentYear);
  return date;
};

const parseAdjustEnd = eventDate => {
  const date = new Date(eventDate);
  date.setFullYear(currentYear);
  date.setHours(date.getHours() + 2);
  return date;
};

export const randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
export const displayDate = new Date(Date.UTC(currentYear, 5, 24));

const groupedData = baseData.reduce((result, item) => {
  const key = item.tripNo;

  if (!result[key]) {
    result[key] = [];
  }

  result[key].push(item);

  return result;
}, {});

const combinedData = Object.keys(groupedData).reduce((result, key) => {
  const group = groupedData[key];

  const shouldCombine = group.length > 1;

  if (shouldCombine) {
    const combinedObject = group.reduce((combined, item) => {        
      return item;
    }, {});

    result.push(combinedObject);
  } else {
    result.push(...group);
  }

  return result;
}, []);

export const sampleDataWithCustomSchema = combinedData.map((dataItem) => ({
  ...dataItem,
  Start: parseAdjust(dataItem.startingDate + ' ' + dataItem.startingTime),
  End: parseAdjustEnd(dataItem.startingDate + ' ' + dataItem.startingTime),
  // TripID: dataItem.tripNo,
  // ContainerID: dataItem.status,
  TaskID: dataItem.sequenceNo,
  ContainerID: 1,
  TripID: 1,
  Title: dataItem.actionCode,
  Description: "",
  StartTimezone: null,
  EndTimezone: null,
  TotalDuration: 5.5, TotalDistance: 95, RecurrenceRule: "FREQ=WEEKLY;BYDAY=WE",

  RecurrenceException: null,
  ImageUrl: "src/assets/images/download.jpg",
  isAllDay: false,
  image: "https://d585tldpucybw.cloudfront.net/sfimages/default-source/default-album/release_webinar_kui_1920x440_lp.png?sfvrsn=23989f80_0"
}));